import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "../../../components/Navbar";
import ChatHistorySidebar from "./ChatHistorySidebar";

const Layout = () => {
  return (
    <div className="h-screen">
      <Navbar />
      <div className="flex w-screen h-[calc(100vh-85px)] bg-white">
        <div>
          <ChatHistorySidebar />
        </div>
        <div className="h-[calc(100vh-85px)] w-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
